export type TAudioContextState = 'closed' | 'running' | 'suspended';
